module.exports = __webpack_public_path__ + "img/icon_plus.02eef04a.svg";